import { Button, ButtonProps } from '@wix/design-system'
import React from 'react'
import { Spinner } from 'react-bootstrap'



type Props = ButtonProps & {
    processing: boolean
    children: React.ReactNode
}

export default function ProcessingButton({ processing, disabled, children, ...rest }: Props) {
    return <Button {...rest} disabled={processing || disabled}>
        <span>

            {processing && <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className='me-1'
            />} {children}
        </span>
    </Button>
}
